import { type ReactNode } from 'react';
import { InView } from 'react-intersection-observer';

import { DataTableLoadingMore } from '../DataTableLoadingMore';

export type DataTableInfiniteScrollProps = {
  root?: Element | null;
  children?: ReactNode;
  itemCount: number;
  hasNextPage: boolean;
  loading: boolean;
  onLoadMore: () => Promise<unknown>;
};

export const DataTableInfiniteScroll = ({
  root,
  children,
  itemCount,
  hasNextPage,
  loading,
  onLoadMore,
}: DataTableInfiniteScrollProps): JSX.Element | null => {
  if (!hasNextPage && !loading) return null;
  return (
    <InView
      key={itemCount}
      root={root}
      skip={!root || loading || !hasNextPage}
      rootMargin="240px"
      onChange={async inView => {
        if (inView && !loading && hasNextPage) await onLoadMore();
      }}
     data-track-source-anchor="d72c585753;data-table-infinite-scroll-in-view">
      {loading && <DataTableLoadingMore>{children}</DataTableLoadingMore>}
    </InView>
  );
};
